import type { IconComponent } from '@naf-simba/building-blocks-icons';
import { Add, Check } from '@naf-simba/building-blocks-icons/General';

type PaywallDetails = {
  isAccessibleForUser?: boolean;
  labelText?: string;
};

type MemberAccessIcon = {
  icon: IconComponent;
  color: 'secondary' | 'primary';
};

type MemberAccessLabel = {
  text: string;
};

type MemberAccess = {
  icon?: MemberAccessIcon;
  label?: MemberAccessLabel;
};

export const mapMemberAccess = (paywallDetails?: PaywallDetails): MemberAccess => {
  if (!paywallDetails) {
    return {};
  }

  const isAccessible = !!paywallDetails.isAccessibleForUser;

  return {
    icon: {
      icon: isAccessible ? Check : Add,
      color: isAccessible ? 'secondary' : 'primary',
    },
    label: {
      text: paywallDetails.labelText || 'For medlemmer',
    },
  };
};
